import React from 'react'
import WeatherIconCloudy from './Icons/WeatherIconCloudy'
import WeatherIconMissing from './Icons/WeatherIconMissing'
import WeatherIconSun from './Icons/WeatherIconSun'
import WeatherIconDayClearSky from './Icons/WeatherIconDayClearSky'
import WeatherIconNightClearSky from './Icons/WeatherIconNightClearSky'
import WeatherIconDaySlightlyCloudy from './Icons/WeatherIconDaySlightlyCloudy'
import WeatherIconNightSlightlyCloudy from './Icons/WeatherIconNightSlightlyCloudy'
import WeatherIconDayLightClouds from './Icons/WeatherIconDayLightClouds'
import WeatherIconNightLightClouds from './Icons/WeatherIconNightLightClouds'
import WeatherIconRain from './Icons/WeatherIconRain'
import WeatherIconSleet from './Icons/WeatherIconSleet'
import WeatherIconSnow from './Icons/WeatherIconSnow'
import WeatherIconDayRainShower from './Icons/WeatherIconDayRainShower'
import WeatherIconNightRainShower from './Icons/WeatherIconNightRainShower'
import WeatherIconDaySnowShower from './Icons/WeatherIconDaySnowShower'
import WeatherIconNightSnowShower from './Icons/WeatherIconNightSnowShower'
import WeatherIconDaySleetShower from './Icons/WeatherIconDaySleetShower'
import WeatherIconNightSleetShower from './Icons/WeatherIconNightSleetShower'
import WeatherIconFog from './Icons/WeatherIconFog'
import WeatherIconFreezingRain from './Icons/WeatherIconFreezingRain'
import WeatherIconThunderstorms from './Icons/WeatherIconThunderstorms'
import WeatherIconDrizzleThunderstorm from './Icons/WeatherIconDrizzleThunderstorm'
import WeatherIconSqualls from './Icons/WeatherIconSqualls'
import WeatherIconDayFunnelCloud from './Icons/WeatherIconDayFunnelCloud'
import WeatherIconNightFunnelCloud from './Icons/WeatherIconNightFunnelCloud'
import WeatherIconWarning from './Icons/WeatherIconWarning'
import WeatherIconWindWarning from './Icons/WeatherIconWindWarning'

export interface BaseWeatherIconProps {
  className?: string
  onWhite?: boolean
}

interface WeatherIconProps extends BaseWeatherIconProps {
  name: string
}

export const WEATHER_ICONS: Record<
  string,
  React.FC<{ onWhite: boolean; className?: string }>
> = {
  '1': WeatherIconDayClearSky,
  '2': WeatherIconDaySlightlyCloudy,
  '3': WeatherIconDayLightClouds,
  '4': WeatherIconCloudy,
  '5': WeatherIconRain,
  '6': WeatherIconSleet,
  '7': WeatherIconSnow,
  '8': WeatherIconDayFunnelCloud,
  '9': WeatherIconDaySnowShower,
  '10': WeatherIconDaySleetShower,
  '11': WeatherIconFog,
  '12': WeatherIconFog,
  '13': WeatherIconFreezingRain,
  '14': WeatherIconThunderstorms,
  '15': WeatherIconDrizzleThunderstorm,
  '16': WeatherIconCloudy,
  '17': WeatherIconDrizzleThunderstorm,
  '18': WeatherIconSqualls,
  '19': WeatherIconDayFunnelCloud,
  '20': WeatherIconDayLightClouds,
  '21': WeatherIconDayFunnelCloud,
  '22': WeatherIconDrizzleThunderstorm,
  '23': WeatherIconDayRainShower,
  '90': WeatherIconSun,
  '101': WeatherIconNightClearSky,
  '102': WeatherIconNightSlightlyCloudy,
  '103': WeatherIconNightLightClouds,
  '104': WeatherIconCloudy,
  '105': WeatherIconRain,
  '106': WeatherIconSleet,
  '107': WeatherIconSnow,
  '108': WeatherIconNightFunnelCloud,
  '109': WeatherIconNightSnowShower,
  '110': WeatherIconNightSleetShower,
  '111': WeatherIconFog,
  '112': WeatherIconFog,
  '113': WeatherIconFreezingRain,
  '114': WeatherIconThunderstorms,
  '115': WeatherIconDrizzleThunderstorm,
  '116': WeatherIconCloudy,
  '117': WeatherIconDrizzleThunderstorm,
  '118': WeatherIconSqualls,
  '119': WeatherIconNightFunnelCloud,
  '120': WeatherIconNightLightClouds,
  '121': WeatherIconNightFunnelCloud,
  '122': WeatherIconDrizzleThunderstorm,
  '123': WeatherIconNightRainShower,
  '190': WeatherIconSun,
  w1: WeatherIconWarning,
  w2: WeatherIconWindWarning,
}

const WeatherIcon: React.FC<WeatherIconProps> = ({
  name,
  onWhite = false,
  className = '',
}) => {
  const IconComponent = WEATHER_ICONS[name] || WeatherIconMissing

  return <IconComponent className={className} onWhite={onWhite} />
}

export default WeatherIcon
